const NameSelector= ({name, onClick, selected}) => {
    return <div onClick={onClick} className={`rounded-md border border-grayu-200 px-3 py-2 w-full flex justify-center cursor-pointer ${selected ? 'bg-tan-300 text-white hover:bg-tan-300': 'text-slate-700 hover:bg-gray-200 duration-300'}`}>
        <h2 className="text-md uppercase">{name}</h2>
    </div>
}

export default NameSelector;